import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchSettings} from '../actions/setting'
import Setting from '../components/Setting'
import {changeFilterDatas} from '../actions/filter'

const mapStateToProps = state => {
  const { setting } = state
  const {
    isFetching,
    lastUpdated,
    items,
    // totalRows
  } = setting || {
    isFetching: true,
    items: []
  }

  return {
    items,
    isFetching,
    lastUpdated,
    // totalRows
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSettings: fetchSettings,
      changeFilterDatas:changeFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
